import { Box } from "../../imports/muiImport";
import { NavLink } from "../../imports/generalImport";

const Poster = (props) => {
    const { path, image, design } = props;
    return (
        <NavLink to={path}>
            <Box component="img"
                src={image}
                alt="entertainment Gaming Poster"
                loading="lazy"
                sx={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    maxHeight: {
                        // lg: "570px",
                        // xl: "570px",
                    },
                    borderRadius: 4,
                    ...design,

                }}
            />
        </NavLink>

    )
}

export default Poster